import { useEffect } from "react";
import "@/App.css";

function App() {
  useEffect(() => {
    document.title = "Reguladas.com";
  }, []);

  return (
    <iframe
      data-testid="rw-frame"
      title="Reguladas.com"
      src="/regulawiki.html"
      style={{
        position: "fixed",
        inset: 0,
        width: "100%",
        height: "100%",
        border: "none",
      }}
    />
  );
}

export default App;
